import React, { useEffect, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import classNames from "classnames";

import { formatUrlWithLocale } from "@helpers/format-url-with-locale";
import { addDividerOnModal } from "@helpers/helpers";

type PropsTypeContent = {
  onClick?: () => void | undefined;
  nameImg: string;
  heading: string;
  description?: string;
  queueModal: number;
};

function ContentRewardsModal({
  onClick,
  nameImg,
  heading,
  description,
  queueModal,
}: PropsTypeContent) {
  const { formatMessage } = useIntl();

  const modalBody = useRef<HTMLDivElement>(null);
  const hr = useRef<HTMLHRElement>(null);

  useEffect(() => {
    addDividerOnModal(modalBody, hr);
    const close = (event: any) => {
      if (event.keyCode === 27) {
        if (onClick) onClick();
      }
    };
    window.addEventListener("keyup", close);

    return () => window.removeEventListener("keyup", close);
  }, [onClick]);

  return (
    // eslint-disable-next-line
    <>
      <div className='modal-header p-4 pb-0 md:p-6 md:pb-0'>
        <div className='relative text-center'>
          <img
            className='mx-auto mb-4'
            src={`/static/img/rewards/complete/${nameImg}.svg`}
            alt={formatMessage({
              id: heading,
            })}
            width={130}
            height={130}
          />
          <h3>
            <FormattedMessage id={heading} />
          </h3>
        </div>
      </div>
      <hr
        className='mx-4 mt-1 border-t-2 border-transparent transition-all md:mx-6'
        ref={hr}
      />
      <div className='modal-body p-4 pt-0 md:p-6 md:pt-0' ref={modalBody}>
        <div className='text-center'>
          <p className='mb-0'>
            <FormattedMessage id={description} />
          </p>
          <p className='mb-0'>
            <FormattedMessage id='get-new-achievement' />
          </p>
          <a
            href={formatUrlWithLocale(`/u${window.apiUserId}/rewards/`)}
            className='prose'
          >
            <FormattedMessage id='more-awards' />
          </a>
          <div>
            <button
              onClick={onClick}
              type='button'
              className='btn btn-primary mt-3 md:mt-4'
            >
              <FormattedMessage id='hooray' />
            </button>
          </div>
        </div>
      </div>
      <div
        className={classNames(
          "shadow-modal-bottom dark:shadow-modal-bottom-dark absolute -bottom-2 left-[2%] -z-10 h-4 w-[96%] rounded-b-lg bg-white dark:bg-black",
          { hidden: queueModal < 1 },
        )}
      />
      <div
        className={classNames(
          "shadow-modal-bottom absolute -bottom-4 left-[4%] -z-20 h-4 w-[92%] rounded-b-lg bg-white dark:bg-black",
          { hidden: queueModal < 2 },
        )}
      />
    </>
  );
}

export default ContentRewardsModal;
